import { defineMessages } from "react-intl";

const messages = defineMessages({
  ready: {
    id: "csvUpload.ready",
  },
  readyDescription: {
    id: "csvUpload.readyDescription",
  },
  done: {
    id: "csvUpload.done",
  },
});

export default messages;
